export default __webpack_public_path__ + "static/gallery-art-ceramics-6271e933cbce689beecd5795f57da92b.jpg";